import { Chakra } from "@airhelp/react-ui-components";
import { useRouter } from "next/router";
import Grid from "modules/common/components/Grid";
import config from "config/config";
import { useTranslations } from "contexts/LocalizationContext";
import { SocialLinksPanel } from "modules/storyblok/components";

const { Flex, Heading } = Chakra;

const Share = () => {
  const router = useRouter();
  const shareUrl = `${config.websiteUrl}${router.asPath}`;
  const translations = useTranslations();

  return (
    <Grid mb={0} pt={{ base: 0, lg: 6 }} pb={{ base: 14, lg: 20 }}>
      <Flex
        gridColumn={{ base: "span 1", md: "span 12" }}
        direction={{ base: "column", lg: "row" }}
        justifyContent="center"
        alignItems="center"
      >
        <Heading variant="h3" as="h3" mr={{ base: 0, lg: 6 }} mb={{ base: 6, lg: 0 }}>
          {translations("share_this_with_your_friends")}
        </Heading>
        <SocialLinksPanel url={shareUrl} title={translations("airhelp_score_2019")} alignItems="center" />
      </Flex>
    </Grid>
  );
};

export default Share;
